module.exports = __webpack_public_path__ + "static/media/ALPHA-BNB.08f32937.svg";